import React from 'react';
import Diversity1Icon from '@mui/icons-material/Diversity1'; // Import the icon
import '../styles/Probono.css';
//add back button for website view

function Probono() {
  return (
    <section className='section align-center text-center'>
      <div className='probonoContent'>
        <Diversity1Icon className='probonoLogo' style={{ fontSize: '4rem', color: '#25D366' }} />
        <h1>Pro Bono Services</h1>
        <p>
          As part of our commitment to supporting those in need, we offer pro bono real estate services to individuals facing financial hardships.
        </p>
        <p>
          This initiative ensures that anyone going through significant life challenges, such as needing to sell their home due to personal circumstances, has access to expert guidance and support—without the financial burden.
        </p>
        <p>
          It’s our way of giving back and making sure everyone gets a fair opportunity in navigating their real estate transactions.
        </p>
      </div>
    </section>

  );
}

export default Probono;